import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ud-footer wow fadeInUp" data-wow-delay=".15s">
      <div className="shape shape-1">
        <img src="/assets/images/footer/shape-1.svg" alt="shape" />
      </div>
      <div className="shape shape-2">
        <img src="/assets/images/footer/shape-2.svg" alt="shape" />
      </div>
      <div className="shape shape-3">
        <img src="/assets/images/footer/shape-3.svg" alt="shape" />
      </div>
      <div className="ud-footer-widgets">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="ud-widget">
                <Link to="/" className="ud-footer-logo" style={{ display: 'inline-block', marginBottom: '15px' }}>
                  <img 
                    src="/assets/images/logo/image.png" 
                    alt="logo" 
                    style={{ 
                      height: '50px',
                      backgroundColor: 'white',
                      padding: '8px 15px',
                      borderRadius: '8px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      display: 'block'
                    }} 
                  />
                </Link>
                <p className="ud-widget-desc" style={{ marginLeft: '20px' }}>
                  AI-powered resume and job description matching for smarter recruitment decisions.
                </p>
                <ul className="ud-widget-socials" style={{ marginLeft: '40px' }}>
                  <li>
                    <a href="https://twitter.com/novamatch">
                      <i className="lni lni-facebook-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/novamatch">
                      <i className="lni lni-twitter-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://instagram.com/novamatch">
                      <i className="lni lni-instagram-filled"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/novalink-solutions-llc/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                      <i className="lni lni-linkedin-original"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-3 col-lg-2 col-md-6 col-sm-6">
              <div className="ud-widget">
                <h5 className="ud-widget-title">About Us</h5>
                <ul className="ud-widget-links">
                  <li>
                    <a href="/#how-it-works">How It Works</a>
                  </li>
                  <li>
                    <a href="/#features">Features</a>
                  </li>
                  <li>
                    <a href="/#contact">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6">
              <div className="ud-widget">
                <h5 className="ud-widget-title">Resources</h5>
                <ul className="ud-widget-links">
                  <li>
                    <Link to="/login">Login</Link>
                  </li>
                  <li>
                    <Link to="/register">Sign Up</Link>
                  </li>
                  <li>
                    <a href="/#faq">FAQ</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
              <div className="ud-widget">
                <h5 className="ud-widget-title">Support</h5>
                <ul className="ud-widget-links">
                  <li>
                    <a href="mailto:support@novamatch.com">Email Support</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ud-footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p className="ud-footer-bottom-right">
                © {currentYear} NovaMatch. All rights reserved.
              </p>
            </div>
            <div className="col-md-6">
              <p className="ud-footer-bottom-right text-end">
                Designed and Developed by <a href="https://novalink-solutions.com" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb', textDecoration: 'none' }}>NovaLink</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
